import { useQueryClient } from '@tanstack/react-query'

import { useContactsServiceDeleteV1IndividualsByIndividualIdContactsByContactId } from '../client/queries'
import { useContactsServiceGetV1IndividualsByIndividualIdContactsKey } from '../client/queries/common'

export const useDeleteContact = () => {
  const queryClient = useQueryClient()

  return useContactsServiceDeleteV1IndividualsByIndividualIdContactsByContactId({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [useContactsServiceGetV1IndividualsByIndividualIdContactsKey],
      })
    },
  })
}
